<template>
    <table class="stage-new-list">
        <thead>
        <tr>
            <td class="stage__col stage__col_name">Название этапа</td>
            <td class="stage__col stage__col_related">Предыдущие этапы</td>
            <td class="stage__col stage__col_responsible">Ответственный</td>
            <td class="stage__col stage__col_duration">Срок в днях</td>
        </tr>
        </thead>

        <tbody>
        <slot></slot>
        </tbody>

        <tfoot>
        </tfoot>
    </table>
</template>

<script>
export default {
    name: "StageNewListTable"
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.stage-new-list {
    width: 75%;
    margin: 0 -8px 20px;

    &, thead {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 100%;
            left: 8px;
            right: 8px;
            border-bottom: 1px solid $secondary;
        }
    }

    tr {
        display: flex;

        &:first-child {
            padding-top: 6px;
        }

        &:last-child {
            padding-bottom: 6px;
        }
    }

    .stage__col {
        padding: 4px 8px;
    }
    .stage__col_name {
        width: 295px;
    }
    .stage__col_related {
        width: 320px;
    }
    .stage__col_responsible {
        width: 360px;
    }
    .stage__col_duration {
        width: 150px;
        text-align: center;
    }
}
</style>